import React, { useState, useEffect, useRef } from "react";
import { MainContainer } from "../../components/MainContainer";
import { Container } from "@prima-afp/prima-ui-elements/dist/layouts";
import Stepper from "../../components/Stepper";
import {
  useStateDigitalTransfersContext,
} from "../../context/DigitalTransfersContext";
import { HeaderStep } from "../../../App/pages/layout-sin-asesor/HeaderSteps";

import { SendButton as SendButtonFundType } from "../../componentes-sin-asesor/StepFundType/SendButton";
import { StepFundType } from "../../componentes-sin-asesor/StepFundType/index"
import { useSubmitOnEnter } from "../../hooks/useSubmitOnEnter";
import { ContainerStepsPage } from "../Style";

export const ReturnStep2 = () => {
  const { stepCurrent } =   useStateDigitalTransfersContext();

  const { buttonRef, handleKeyDown } = useSubmitOnEnter();

  const [isMobile, setIsMobile] = useState(window.innerWidth < 445);

  const handleResize = () => {
    setIsMobile(window.innerWidth < 445);
  };

  const stepList = [
    {
      id: 0,
      title: "Bríndanos tus datos de contacto",
      subtitle: "Siguiente paso: Información para tu nueva cuenta",
    },
    {
      id: 1,
      title: "Bríndanos tus datos de contacto",
      subtitle: "Siguiente paso: Información para tu nueva cuenta",
    },
    {
      id: 2,
      title: "Elige tu tipo de fondo",
      subtitle: "Siguiente paso: Valida tu identidad con una selfie",
    },
    {
      id: 3,
      title: "Valida tu identidad con una selfie",
      subtitle: "Último paso: Valida tus datos de contacto",
    },
    { id: 4, title: "Valida tus datos de contacto", subtitle: "" },
  ];

  useEffect(() => {
    // Agregamos el event listener cuando el componente se monta
    window.addEventListener("resize", handleResize);

    // Limpiamos el event listener cuando el componente se desmonta
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);


  return (
    <div
      id="wrapperStepsId"
      onKeyDown={handleKeyDown}
      style={{ width: "100%" }}
    >
      {!isMobile && (
        <Container id="idContainerHeader">
          <HeaderStep />
        </Container>
      )}

      <MainContainer id="idMainContainer">
        <Stepper stepList={stepList} currentStep={stepCurrent} />
        <StepFundType />
      </MainContainer>
      <ContainerStepsPage>
        <SendButtonFundType buttonRef={buttonRef}/>
      </ContainerStepsPage>

      {isMobile && (
        <Container id="idContainerHeader MBtn">
          <HeaderStep isMobile={isMobile} />
        </Container>
      )}

    </div>
  );
};
